module.exports = __webpack_public_path__ + "static/media/2.34e79239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = 67
// module chunks = 0